import { CIMSPage } from '@cims-online/shared'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { HelpMessage } from 'utils/constants'
import { DSType } from '../../../TypesTableContext'

export function useExpand(): ExpandOptions<DSType> {
  return {
    expandable: ({ submittals }) => !!submittals.length,
    render: ({ id, submittals }) => {
      return {
        additionalInfo: [
          {
            label: 'Associated Submittals',
            help: HelpMessage.DesignSubmittals.Types.AssociatedSubmittals,
            type: 'deepLinks',
            showMore: { key: id },
            links: submittals.map(
              ({ packageName, deleted, id, packageNumber }) => ({
                label: packageNumber,
                tooltip: packageName,
                page: CIMSPage.DSLog,
                deep: {
                  recordId: id,
                  deleted,
                },
              })
            ),
          },
        ],
      }
    },
  }
}
